import {
  useEffect,
  useState,
} from "react";
import { Card, Grid, CardContent, Typography, Divider } from "@mui/material";
import Chart from "react-google-charts";
import "./style.css";
import axios from "axios";
import api from "../../utils/Url";
import Active from "../../assets/images/Activ.png";
import news from "../../assets/images/news.png";
import Modal from "@mui/material/Modal";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import { VehicleRfid, WeightChart } from "../../type";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";
import { text } from "stream/consumers";
import IssueReturn from "../Library/IssueReturn/IssueReturn";


export const options1 = {
  // title: "Weight of the vehicle",
  pieHole: 0.25,
  is3D: false,
  legend: "top",
};

function createData(
  srno: number,
  id: string,
  notice: string,
  description: string,
  fromDate: string,
  toDate: string,
  noticeLink: string
): any {
  return { srno, id, notice, description, fromDate, toDate, noticeLink };
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  height: "85%",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

export default function HomePage() {
  const [noticeRecords, setNoticeRecords] = useState<any>([]);

  const [totAdvertisement, setTotAdvertisement] = useState("");
  const [totApplied, setTotApplied] = useState("");
  const [totVacantHolding, setTotVacantHolding] = useState("");
  const [totApproved, setTotApproved] = useState("");
  const [chartData, setChartData] = useState<any>("");
  const [showModal, setShowModal] = useState(false);
  const [selectedZone, setSelectedZone] = useState("Zone 1");

  const [showModal1, setShowModal1] = useState(false);
  const [hoardingModalData, setHoardingModalData] = useState(false);

  const [hoardingData, setHoardingData] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);

  const { t } = useTranslation();

  const handleTotalCategoryClick = () => {
    setShowModal1(!showModal1);
  };

  const handleHoardingData = () => {
    // console.log("check click", hoardingModalData);
    setHoardingModalData(true);
  };

  const handleCloseHoardingModal = () => {
    setHoardingModalData(false);
  };

  useEffect(() => {
    //getHoardingData();
   // getChartData();
   // getHoardingDetails();
      const tokenDataString:any = sessionStorage.getItem('token');
      // console.log("token",tokenDataString)
  }, []);

  

  const handleClick = async (id: any) => {
    const collectDatas = {
      noticeID: id,
      user_ID: -1,
      isActive: true,
    };
    // console.log(collectDatas);
    let noticeFile: any = [];
    await api
      .post(`Notice/GetNoticeMaster`, collectDatas)
      .then((res) => noticeFile.push(res.data.data[0]["noticeDoc"]));
    try {
      const pdfDataUri = `data:application/pdf;base64,${noticeFile}`;
      const newWindow = window.open("", "_blank");
      if (newWindow !== null) {
        newWindow.document.write(
          `<iframe src="${pdfDataUri}" width="100%" height="100%" ></iframe>`
        );
      }
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const getHoardingData = () => {
    api
      .get(`AssigningRfid/CountTotAssign`)
      .then((res) => {
        // console.log("count data", res.data.data);
        setTotAdvertisement(res.data.data.totalFile);
        setTotApplied(res.data.data.totalIssue);
        setTotVacantHolding(res.data.data.totEpcNotapprove);
        setTotApproved(res.data.data.totEpcapprove);
      });
  };



  const getHoardingDetails = () => {
    api
      .get( `Dashboard/GetPendingDataShow`)
      .then((res) => {
        // console.log("check Hoarding", res.data.data);
        setHoardingData(res.data.data);
      });
  };


  const getChartData = () => {
    const collectData = {
      zoneID: -1,
      user_ID: 0,
    };
    api
      .post(
        `Dashboard/GetDashboardZoneMaster`,
        collectData
      )
      .then((res) => {
        const data = formatChartData(res.data.data);
        setChartData(data); // Make sure this updates the state correctly
      })
      .catch((error) => {
        // console.error("Error fetching chart data: ", error);
      });
  };

  const formatChartData = (data: any) => {
    const formattedData = [["Zone", "Ward Count", "wardData"]];
    data.forEach((zone: any) => {
      formattedData.push([
        zone.zoneName,
        zone.dashboardWard.length,
        zone.dashboardWard,
      ]);
    });
    return formattedData;
  };

  const handleChartSelect = (chartWrapper: any) => {
    const selection = chartWrapper.getChart().getSelection();
    if (selection.length === 1) {
      const item = chartData[selection[0].row + 1];
      if (item) {
        setSelectedZone(item[0]); // Set selected zone
        setShowModal(true); // Open modal
      }
    }
  };


  const options1 = {
    pieSliceText: "value",
    pieSliceTextStyle: {
      color: "white",
      bold: true,
    },
    slices: {
      0: { offset: 0.1, color: "#3366cc" },
      1: { offset: 0.1, color: "#dc3912" },
    },
    legend: {
      position: "top",
    },
  };

  return (
    <>
    <IssueReturn/>
    </>

  );
}
